import React from 'react';
import { ACCENT_COLOR } from './colors';

const Logo = ({
  width = 54,
  className = '',
}) => (
  <svg
    className={`svg-icon ${className || ''}`}
    width={width}
    height={width / 0.9}
    viewBox="0 0 54 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g clipPath="url(#clip-logo)">
      <path d="M27 0L0 47H54L27 0Z" fill="#E5E6E6" />
      <path d="M37 34L30 21H0L23 60L37 34Z" fill={ACCENT_COLOR} />
    </g>
    <defs>
      <clipPath id="clip-logo">
        <rect width="54" height="60" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Logo;
